window.toggleMobileMenu = function toggleMobileMenu() {
  const mobileMenu = document.querySelector('.mobile-menu');

  if (!mobileMenu) {
    return;
  }

  mobileMenu.classList.toggle('active');
};

window.closeMobileMenu = function closeMobileMenu() {
  const mobileMenu = document.querySelector('.mobile-menu');

  if (!mobileMenu) {
    return;
  }

  mobileMenu.classList.remove('active');
};

document.querySelectorAll(".accordion").forEach((item) => {
  item.querySelector(".accordion__header").addEventListener("click", () => {
    item.classList.toggle("open");
  });
});